import { DialogTracking } from "components/Dialog/components/DialogTracking.ts";
import { read } from "hooks/useSession.ts";
import { createSlice, PayloadAction, SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

const dialogState = read("_dialogState");

export interface DialogAPIInfo {
	apiError?: FetchBaseQueryError | SerializedError;
	isLoadingAPI?: boolean;
	isSuccessAPI?: boolean;
}

export interface DialogStateSlice {
	dialogStatus: DialogTracking;
	dialogIndex?: number;
	dialogId?: string | null;
	dialogLeavePath?: string | null;
	apiInfo?: DialogAPIInfo;
	dialogData?: any;
}

export const initialState: DialogStateSlice = dialogState || {
	dialogStatus: DialogTracking.NONE,
	dialogIndex: undefined,
	dialogId: undefined,
	dialogLeavePath: undefined,
	apiInfo: undefined,
	dialogData: undefined
};

const dialogStateSlice = createSlice({
	name: "dialogState",
	initialState,
	reducers: {
		setDialogStatus: (state: DialogStateSlice, action: PayloadAction<DialogTracking>) => {
			state.dialogStatus = action.payload;
		},
		setDialogIndex: (state: DialogStateSlice, action: PayloadAction<number | undefined>) => {
			state.dialogIndex = action.payload;
		},
		setDialogId: (state: DialogStateSlice, action: PayloadAction<string | undefined | null>) => {
			state.dialogId = action.payload;
		},
		setDialogLeavePath: (state: DialogStateSlice, action: PayloadAction<string | undefined | null>) => {
			state.dialogLeavePath = action.payload;
		},
		setDialogData: (state: DialogStateSlice, action: PayloadAction<any>) => {
			state.dialogData = action.payload;
		},
		clearDialogStatus: (state, action: PayloadAction<boolean>) => {
			state.dialogStatus = DialogTracking.NONE;
			state.dialogIndex = undefined;
			state.dialogId = undefined;
			state.dialogLeavePath = undefined;
			state.dialogData = undefined;
			if (action.payload) {
				state.apiInfo = undefined;
			}
		},
		setDialogAPIInfo: (state, action: PayloadAction<DialogAPIInfo | undefined>) => {
			state.apiInfo = action.payload;
		}
	}
});

export const dialogStateActions = dialogStateSlice.actions;
export default dialogStateSlice.reducer;
